import {External, M} from "../../../external";
import {resource} from "../../../Common/tools";

export function isValidSMSMessage(message) {
  return message?.body?.length;
}

export function isValidVoiceMessage(message) {
  try {
    return message && validateVoiceMessage(message);
  } catch (e) {
    return false;
  }
}

export function isValidWhatsAppMessage(message) {
  try {
    return message && validateWhatsAppMessage(message);
  } catch (e) {
    return false;
  }
}

export function isValidWhatsAppAttachment(url) {
  if (url?.length) {
    if (External.Website.isTwilioEnabled()) { //types allowed by twilio
      return ["jpg", "jpeg", "png", "webp"/*, "ogg", "amr", "3gp", "aac", "mpeg", "pdf", "doc", "docx", "pptx", "xlsx", "mp4", "vcf"*/].includes(getExtension(url));
    }
    //add future apps here
  }
  return false;
}

export function isValidAudioFile(url) {
  if (url?.length) {
    if (External.Website.isTwilioEnabled()) {
      return ["mp3", "wav", "wave", "aiff", "aifc", "gsm", "ulaw"].includes(getExtension(url));
    }
    //add future apps here
  }
  return false;
}

function getExtension(url) {
  const lastIndex = url.lastIndexOf("?");
  return url.substring(url.lastIndexOf(".") + 1, lastIndex > -1 ? lastIndex : url.length);
}

export function getAttachmentName(attachment) {
  const lastIndex = attachment.url.lastIndexOf("?");
  return attachment.url.substring(attachment.url.lastIndexOf('/') + 1, lastIndex > -1 ? lastIndex : attachment.url.length)
}

export function validateSMSMessage(message) {
  if (!message.body?.length) {
    throw M.INVALID_MESSAGE_BODY;
  }
  return true;
}

export function validateWhatsAppMessage(message) {
  if (message.attachments?.length) {
    for (let i = 0; i < message.attachments.length; i++) {
      if (!isValidWhatsAppAttachment(message.attachments[i].name)) {
        throw M.INVALID_WHATSAPP_ATTACHMENT;
      }
      setAttachmentUrl(message.attachments[i]);
    }
  } else {
    if (!message.body) {
      throw M.INVALID_MESSAGE_BODY;
    }
  }
  return true;
}

export function validateVoiceMessage(message) {
  if (message.attachments?.length) {
    if (message.body && message.voiceType === '0') {
      throw M.INVALID_VOICE;
    }
    for (let i = 0; i < message.attachments.length; i++) {
      if (!isValidAudioFile(message.attachments[i].url)) {
        throw M.INVALID_AUDIO_URL;
      }
      try {
        new URL(message.attachments[i].url);
      } catch (e) {
        throw M.INVALID_AUDIO_URL;
      }
    }
  } else {
    if (message.voiceType === '0') {
      throw M.INVALID_VOICE;
    }
    if (!message.body) {
      throw M.INVALID_VOICE_MESSAGE;
    }
  }
  return true;
}

export function setAttachmentUrl(attachment) {
  attachment.url = External.getFileFromBase(attachment.base) + attachment.name + "?format=webp";   //TODO add type check if we add more attachment types
}

export function hasValidAttachments(message) {
  return !!message.attachments?.find(att => Object.keys(att).find(key => !!att[key]));
}

export function appendProperty(message, textarea) {
  let cursorPosition = textarea && typeof textarea.selectionStart !== "undefined" ? textarea.selectionStart : -1;

  return new Promise((resolve) => {
    External.UITools.selectMarketingProperty(null, tag => {
      let channelMaxLength = getChannelMessageMaxLength(message.channel);
      let newBody;

      if (cursorPosition >= 0 && cursorPosition < message.body.length) {
        newBody = message.body.substring(0, cursorPosition) + '{' + tag + '}' + message.body.substring(cursorPosition);
      } else {
        newBody = message.body + '{' + tag + '}';
      }

      resolve(newBody.length > channelMaxLength ? message.body : newBody); //dont add the tag if the body exceeds the channel max length
    });
  });
}

export function getChannelMessageMaxLength(channel) {
  if (External.Website.isTwilioEnabled()) {
    switch (channel) {
      case External.CRM_MESSAGE_CHANNEL.SMS:
        return 320;
      case External.CRM_MESSAGE_CHANNEL.WHATSAPP:
        return 1600;
      case External.CRM_MESSAGE_CHANNEL.VOICE:
        return 4000;
    }
  }
  //add future apps here
  return 0;
}

export function getChannelAttachmentLimit(channel) {
  if (External.Website.isTwilioEnabled()) {
    switch (channel) {
      case External.CRM_MESSAGE_CHANNEL.WHATSAPP:
      case External.CRM_MESSAGE_CHANNEL.VOICE:
        return 1;
    }
  }
  //add future apps here
  return 1;
}

export function getChannelIcon(channel) {
  switch (channel) {
    case External.CRM_MESSAGE_CHANNEL.SMS:
      return resource('/images/messages/sms.png');
    case External.CRM_MESSAGE_CHANNEL.WHATSAPP:
      return resource('/images/messages/whatsapp.png');
    case External.CRM_MESSAGE_CHANNEL.VOICE:
      return resource('/images/messages/voice.png');
  }
}

export function addAttachment(attachments, channel) {
  if (attachments.length < getChannelAttachmentLimit(channel)) {
    attachments[attachments.length] = {};
  }
}

export function toggleAttachments(message) {
  if (message.attachments) {
    message.attachments = null;
  } else {
    message.attachments = [];
    addAttachment(message.attachments, message.channel);
  }
  return message.attachments;
}

export function makeRequest(action, params) {
  return new Promise((resolve, reject) => {
    External.Tools.makeWebsiteRequest({
      action: action, data: params, onOk: (resp) => {
        if (resp.data) {
          resolve(resp.data);
        } else {
          reject(resp);
        }
      }, onNotOk: (resp) => {
        reject(resp);
      }
    });
  });
}

export function connectSettings(onSave) {
  const popup = External.Website.settingsUI.showAppSettings("twilio", onSave);
  window.setTimeout(() => {
    popup.close();
  }, 1750);
}
